import { AutenticationEventType } from './../../../../autentication/autentication.event.type';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';
import { InvestmentsPeriodEventType } from '../investments-period.event.type';
import { CurrentBalanceEventType } from '../../../../shared/current-balance/current-balance.event.type';

@Component({
	selector: 'app-period-filter',
	templateUrl: './period-filter.component.html',
	styleUrls: ['./period-filter.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PeriodFilterComponent implements OnInit, OnDestroy {

	formPeriod: FormGroup;
	periodOpened = false;

	dateBeginError = false;
	dateEndError = false;

	@Input() submited: boolean;

	constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
		this.formPeriod = formBuilder.group({
			'dateBegin': [null, Validators.required],
			'dateEnd': [null, Validators.required]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(CurrentBalanceEventType.BALANCE_UPDATE, () => {
			this.onSubmit();
		});

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.onSubmit();
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CurrentBalanceEventType.BALANCE_UPDATE);
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
	}

	onSubmit() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

		if (this.formPeriod.valid) {

			if (moment(this.formPeriod.controls.dateBegin.value).isSameOrBefore(this.formPeriod.controls.dateEnd.value)) {
				this.dateBeginError = false;
				this.dateEndError = false;

				TweenMax.delayedCall(.4, () => {

					this.submited = true;
					AppEventDispatcher.dispatch(InvestmentsPeriodEventType.UPDATE, {
						dateBegin: this.formPeriod.value.dateBegin,
						dateEnd: this.formPeriod.value.dateEnd
					});

				});

			} else {
				this.dateEndError = true;
				this.dateBeginError = true;

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'A data inicial, deve ser menor que a data final.'});
			}

		}

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-period/period-filter/period-filter.component.ts